import React from 'react';

import {PlanHolding} from '@/b2c/PlanDetail/Detail/PlanHolding';
import Portfolio from '@/b2c/PlanDetail/Detail/FundPlatformDetail/Portfolio';

const FundPlatformDetail = ({plan}) => (
  <>
    <PlanHolding plan={plan} />
    <Portfolio currentPlan={plan} />
  </>
);

export default FundPlatformDetail;
